// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* PR Changes */
.main-menu {
  background-color: var(--white);
  justify-content: space-between;
  align-items: center;
  padding: 8px 2%;
  display: flex;
}

.menu-container {
  display: flex;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  justify-content: space-between;
}

/* .menu-logo-2 {
  background-image: url(../src/styles/images/main_brand_bbi-logo.svg);
  background-position: 0%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 200px;
  height: 60px;
} */

.prv2-user-guide-label {
  display: flex;
  height: 2rem;
  padding-right: 33px;
  padding-left: 10px;
  align-items: center;
  border-radius: 100px;
  background-color: #fff;
  /* background-image: url("../src/styles/images/635d2aeb482d4aea4f0219a3_user-guide-color.svg"); */
  background-position: 96% 50%;
  background-size: auto 80%;
  background-repeat: no-repeat;
  color: #ef6a00;
  font-size: 0.7rem;
  font-weight: 500;
}

.userguide-btn {
  text-decoration: none !important;
  cursor: pointer !important;
}

.w-dropdown-toggle {
  -webkit-user-select: none;
  user-select: none;
  display: inline-block;
  cursor: pointer;
  padding-right: 40px;
}

.w-dropdown-btn,
.w-dropdown-toggle,
.w-dropdown-link {
  position: relative;
  vertical-align: top;
  text-decoration: none;
  /* color: #222222; */
  padding: 20px;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  white-space: nowrap;
}

.user-dropdown {
  margin-left: 5px;
  margin-right: 0px !important;
}

.w-dropdown {
  display: inline-block;
  position: relative;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  z-index: 900;
}

.user-dd-toggle {
  display: flex;
  width: 35px;
  height: 35px;
  padding: 0px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #005681;
  font-size: 1rem;
  line-height: 15px;
  font-weight: 600;
  text-align: center;
}

.user-dropdown-list {
  left: auto;
  top: 0%;
  right: 0%;
  bottom: auto;
  margin-top: 40px;
  padding-top: 0px;
  background-color: transparent;
}

.user-dropdown-list.w--open {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.user-dd-link {
  padding-top: 6px;
  padding-bottom: 6px;
  background-color: #fff;
}

.user-dd-link:hover {
  color: #c63363;
  cursor: pointer;
}
/* .user-dd-link.logoutBtn {
  background-image: url(../src/styles/images/logout.png);
  background-size: auto 17px;
  background-repeat: no-repeat;
  background-position: 4px 10px;
  text-align: center;
  padding: 10px 30px 10px 30px;
} */

/* .user-dd-link.logoutBtn:hover {
  background-image: url(../src/styles/images/LogoutHover.png);
} */

.user-dd-list-wrapper {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 3px -2px 11px 4px rgba(0, 0, 0, 0.11);
  font-size: 12px;
}

.w-dropdown-list {
  position: absolute;
  display: none;
  min-width: 100%;
}

.w-dropdown-link {
  padding: 10px 20px;
  display: block;
  color: #222222;
}
.w-dropdown-link.w--current {
  color: #0082f3;
}
.w-dropdown-link:focus {
  outline: 0;
}

/* .dd-triangle-icon {
  width: 23px;
  height: 10px;
  margin-right: 8px;
  background-image: url("/public/Images/62e90c764af443788e829909_arrow-white-up.svg");
  background-position: 50% 100%;
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  top: -10px;
  right: 0;
} */

/* .loader {
  display: none;
  width: 100%;
  height: 100%;
  background-image: url(./styles/images/preloader-gif.gif) !important;
  background-position: 50% 50vh !important;
  background-size: 60px !important;
  background-repeat: no-repeat !important;
} */
.loader.show {
  display: block !important;
  position: fixed;
  cursor: progress !important;
  z-index: 99999;
}

/* .overlay-loading {
  width: 100%;
  height: 100%;
  background-image: url(./styles/images/preloader-gif.gif) !important;
  background-position: center !important;
  background-size: 60px !important;
  background-repeat: no-repeat !important;
  display: block !important;
  position: fixed;
  cursor: progress !important;
  z-index: 99999;
  align-items: center;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
} */
.empty-table-cell {
  width: 100%;
  justify-content: center;
}

.padding-left20-right20 {
  padding-left: 20px;
  padding-right: 20px;
}
.parent-container {
  width: 100%;
  flex: 1 1;
}
.parent-container > .container {
  width: 100%;
  max-width: 100%;
}
.overlay-loading
  .content-container
  .roles-tab-pane.w-tab-pane.w--tab-active
  > .w-tab-pane-sub-content
  .MuiPaper-root {
  visibility: hidden;
}
.roles-container {
  width: 100%;
}
.overlay-loading .content-container .roles-container {
  width: 100%;
}
.users-heading {
  display: flex;
  justify-content: center;
  padding: 10px;
}

e-treegrid .e-image {
  height: 13px;
  width: 14px;
  vertical-align: middle;
}

.statustemp {
  position: relative;
  border-radius: 15px;
  text-align: center;
  background-color: #c3f1d0;
  color: #00752f;
  width: 47px;
  height: 22px;
}

.statustemp.e-lowgdp {
  background-color: #ffdbdb;
  color: #bd0000;
}

td.e-rowcell .statustxt {
  color: #398120;
  position: relative;
}

td.e-rowcell .statustxt.e-lowgdp {
  color: #e60000;
  position: relative;
}

.rating .star {
  font-size: 132%;
  color: lightgrey;
}

.rating .star.checked {
  color: #ee9e54;
}

.rating .star:before {
  content: "★";
}
.negativeTimeZone {
  transform: rotate(180deg);
}
#myBar {
  position: absolute;
  width: 10%;
  height: 100%;
  background-color: #00b300;
}

#myBar.progressdisable {
  background-color: #df2222;
}

#treegridlabel {
  position: relative;
  left: 10px;
  line-height: 18px;
  font-size: 10px;
  color: white;
}
.highcontrast .e-grid #myProgress {
  background-color: whitesmoke;
}
#myProgress {
  position: relative;
  height: 18px;
  width: 10em;
  text-align: left;
  background-color: whitesmoke;
}
#myBar.progressdisable {
  background-color: #df2222;
}

#coordinates .e-image {
  filter: brightness(180%);
}
.material3-dark .rating .star.checked,
.material3 .rating .star.checked {
  color: #6750a4;
}

.material3-dark #myBar,
.material3 #myBar {
  background-color: #53ca17;
}

.material3-dark #myBar.progressdisable,
.material3 #myBar.progressdisable {
  background-color: rgba(242, 184, 181, 1);
}

.e-rowcell.e-treerowcell {
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EAIjB,8BAA8B;AAChC;;AAEA;;;;;;;GAOG;;AAEH;EAIE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAIlB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,iGAAiG;EACjG,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EAGzB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;EAIZ,uBAAuB;EAIvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,OAAO;EACP,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;;;;;;;GAOG;;AAEH;;GAEG;;AAEH;EAIE,aAAa;EACb,gBAAgB;EAKhB,sBAAsB;EACtB,kBAAkB;EAClB,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA;;;;;;;;;;;GAWG;;AAEH;;;;;;;;GAQG;AACH;EACE,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;GAgBG;AACH;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,SAAO;AACT;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;;;;;EAKE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;AACA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* PR Changes */\n.main-menu {\n  background-color: var(--white);\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 2%;\n  display: flex;\n}\n\n.menu-container {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n/* .menu-logo-2 {\n  background-image: url(../src/styles/images/main_brand_bbi-logo.svg);\n  background-position: 0%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 200px;\n  height: 60px;\n} */\n\n.prv2-user-guide-label {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 2rem;\n  padding-right: 33px;\n  padding-left: 10px;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 100px;\n  background-color: #fff;\n  /* background-image: url(\"../src/styles/images/635d2aeb482d4aea4f0219a3_user-guide-color.svg\"); */\n  background-position: 96% 50%;\n  background-size: auto 80%;\n  background-repeat: no-repeat;\n  color: #ef6a00;\n  font-size: 0.7rem;\n  font-weight: 500;\n}\n\n.userguide-btn {\n  text-decoration: none !important;\n  cursor: pointer !important;\n}\n\n.w-dropdown-toggle {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  display: inline-block;\n  cursor: pointer;\n  padding-right: 40px;\n}\n\n.w-dropdown-btn,\n.w-dropdown-toggle,\n.w-dropdown-link {\n  position: relative;\n  vertical-align: top;\n  text-decoration: none;\n  /* color: #222222; */\n  padding: 20px;\n  text-align: left;\n  margin-left: auto;\n  margin-right: auto;\n  white-space: nowrap;\n}\n\n.user-dropdown {\n  margin-left: 5px;\n  margin-right: 0px !important;\n}\n\n.w-dropdown {\n  display: inline-block;\n  position: relative;\n  text-align: left;\n  margin-left: auto;\n  margin-right: auto;\n  z-index: 900;\n}\n\n.user-dd-toggle {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 35px;\n  height: 35px;\n  padding: 0px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 50%;\n  background-color: #005681;\n  font-size: 1rem;\n  line-height: 15px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.user-dropdown-list {\n  left: auto;\n  top: 0%;\n  right: 0%;\n  bottom: auto;\n  margin-top: 40px;\n  padding-top: 0px;\n  background-color: transparent;\n}\n\n.user-dropdown-list.w--open {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n}\n\n.user-dd-link {\n  padding-top: 6px;\n  padding-bottom: 6px;\n  background-color: #fff;\n}\n\n.user-dd-link:hover {\n  color: #c63363;\n  cursor: pointer;\n}\n/* .user-dd-link.logoutBtn {\n  background-image: url(../src/styles/images/logout.png);\n  background-size: auto 17px;\n  background-repeat: no-repeat;\n  background-position: 4px 10px;\n  text-align: center;\n  padding: 10px 30px 10px 30px;\n} */\n\n/* .user-dd-link.logoutBtn:hover {\n  background-image: url(../src/styles/images/LogoutHover.png);\n} */\n\n.user-dd-list-wrapper {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  border-radius: 3px;\n  box-shadow: 3px -2px 11px 4px rgba(0, 0, 0, 0.11);\n  font-size: 12px;\n}\n\n.w-dropdown-list {\n  position: absolute;\n  display: none;\n  min-width: 100%;\n}\n\n.w-dropdown-link {\n  padding: 10px 20px;\n  display: block;\n  color: #222222;\n}\n.w-dropdown-link.w--current {\n  color: #0082f3;\n}\n.w-dropdown-link:focus {\n  outline: 0;\n}\n\n/* .dd-triangle-icon {\n  width: 23px;\n  height: 10px;\n  margin-right: 8px;\n  background-image: url(\"/public/Images/62e90c764af443788e829909_arrow-white-up.svg\");\n  background-position: 50% 100%;\n  background-size: contain;\n  background-repeat: no-repeat;\n  position: absolute;\n  top: -10px;\n  right: 0;\n} */\n\n/* .loader {\n  display: none;\n  width: 100%;\n  height: 100%;\n  background-image: url(./styles/images/preloader-gif.gif) !important;\n  background-position: 50% 50vh !important;\n  background-size: 60px !important;\n  background-repeat: no-repeat !important;\n} */\n.loader.show {\n  display: block !important;\n  position: fixed;\n  cursor: progress !important;\n  z-index: 99999;\n}\n\n/* .overlay-loading {\n  width: 100%;\n  height: 100%;\n  background-image: url(./styles/images/preloader-gif.gif) !important;\n  background-position: center !important;\n  background-size: 60px !important;\n  background-repeat: no-repeat !important;\n  display: block !important;\n  position: fixed;\n  cursor: progress !important;\n  z-index: 99999;\n  align-items: center;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n} */\n.empty-table-cell {\n  width: 100%;\n  justify-content: center;\n}\n\n.padding-left20-right20 {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.parent-container {\n  width: 100%;\n  flex: 1;\n}\n.parent-container > .container {\n  width: 100%;\n  max-width: 100%;\n}\n.overlay-loading\n  .content-container\n  .roles-tab-pane.w-tab-pane.w--tab-active\n  > .w-tab-pane-sub-content\n  .MuiPaper-root {\n  visibility: hidden;\n}\n.roles-container {\n  width: 100%;\n}\n.overlay-loading .content-container .roles-container {\n  width: 100%;\n}\n.users-heading {\n  display: flex;\n  justify-content: center;\n  padding: 10px;\n}\n\ne-treegrid .e-image {\n  height: 13px;\n  width: 14px;\n  vertical-align: middle;\n}\n\n.statustemp {\n  position: relative;\n  border-radius: 15px;\n  text-align: center;\n  background-color: #c3f1d0;\n  color: #00752f;\n  width: 47px;\n  height: 22px;\n}\n\n.statustemp.e-lowgdp {\n  background-color: #ffdbdb;\n  color: #bd0000;\n}\n\ntd.e-rowcell .statustxt {\n  color: #398120;\n  position: relative;\n}\n\ntd.e-rowcell .statustxt.e-lowgdp {\n  color: #e60000;\n  position: relative;\n}\n\n.rating .star {\n  font-size: 132%;\n  color: lightgrey;\n}\n\n.rating .star.checked {\n  color: #ee9e54;\n}\n\n.rating .star:before {\n  content: \"★\";\n}\n.negativeTimeZone {\n  transform: rotate(180deg);\n}\n#myBar {\n  position: absolute;\n  width: 10%;\n  height: 100%;\n  background-color: #00b300;\n}\n\n#myBar.progressdisable {\n  background-color: #df2222;\n}\n\n#treegridlabel {\n  position: relative;\n  left: 10px;\n  line-height: 18px;\n  font-size: 10px;\n  color: white;\n}\n.highcontrast .e-grid #myProgress {\n  background-color: whitesmoke;\n}\n#myProgress {\n  position: relative;\n  height: 18px;\n  width: 10em;\n  text-align: left;\n  background-color: whitesmoke;\n}\n#myBar.progressdisable {\n  background-color: #df2222;\n}\n\n#coordinates .e-image {\n  filter: brightness(180%);\n}\n.material3-dark .rating .star.checked,\n.material3 .rating .star.checked {\n  color: #6750a4;\n}\n\n.material3-dark #myBar,\n.material3 #myBar {\n  background-color: #53ca17;\n}\n\n.material3-dark #myBar.progressdisable,\n.material3 #myBar.progressdisable {\n  background-color: rgba(242, 184, 181, 1);\n}\n\n.e-rowcell.e-treerowcell {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
